<template>
    <div :id="'LqsAnalyser' + viewASINsDetailedData[0].asins">
        <div class="container-fluid" style="padding: 0px !important">
            <!-- <div style="margin: 0">
                <div style="margin: 0; padding-bottom: 0 !important" class="mainHeading d-flex justify-content-end">
                     <span style="color: var(--primary_brand); font-size: 16px" class="mr-3" v-if="viewLqsListingdata.product_meta.product_link.includes('www.amazon.in')">
                     <img src="../../../public/img/IndiaFlag.svg" width="22" class="">
                        amazon.in</span>
                    <span style="color: var(--primary_brand); font-size: 16px"  class="mr-3"  v-if="viewLqsListingdata.product_meta.product_link.includes('www.amazon.com')">
                        <img src="../../../public/img/USflag.svg"  width="22" class="">
                        amazon.com
                    </span>
                    <span style="color: var(--primary_brand); font-size: 16px">{{
                        timestamp
                    }}</span>
                    <span class="ml-2 screenshot-btn" @click="takeScreenshot"><i
                            class="fa fa-download cursor-pointer text-primary bg-black px-2 py-1 border border-success rounded"
                            aria-hidden="true"></i>
                    </span>
                </div>
            </div>
            <div class="row p-2">
                <div class="productCart">
                    <div class="productImg">
                        <img :src="viewLqsListingdata.product_meta.product_image" crossorigin="anonymous" />
                    </div>
                    <div class="ml-2">
                        <a :href="viewLqsListingdata.product_meta.product_link" target="_blanck"
                            class="cursor-pointer textColor product-title" syte>{{
                                viewLqsListingdata.product_meta.product_name }} <span v-if="asinData"
                                style="font-weight:bold">({{ asinData }})</span></a>
                    </div>
                </div>
            </div>
            <div class="row p-2">
                <div class="col-3">
                    <div class="border rounded">
                        <div style="text-align: center">
                            <highcharts :options="gaugeChartData"></highcharts>
                        </div>
                        <div class="text-center graphCount">{{ viewLqsGraph }}</div>
                    </div>
                </div>
                <div class="col-9">
                    <div class="row">
                        <div class="col sideBorder">
                            <div class="secondaryHeading mb-2">Copy Breakdown</div>
                            <div class="space-between-header" v-for="(row, i) in viewLqsListingdata.copy_breakdown"
                                :key="'lqs_cb' + i">
                                <div class="textColor" style="text-transform: capitalize">
                                    <i class="fa fa-circle trueIcon mr-2" aria-hidden="true"
                                        :class="{ falseIcon: row.status == false }"></i>
                                    {{ row.label }}
                                    <i class="fa fa-info-circle cursor-pointer" aria-hidden="true" :title="row.label"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col sideBorder">
                            <div class="secondaryHeading mb-2">Media Breakdown</div>
                            <div class="space-between-header" v-for="(row, i) in viewLqsListingdata.media_breakdown"
                                :key="'lqs_cb' + i">
                                <div class="textColor" style="text-transform: capitalize">
                                    <i class="fa fa-circle trueIcon mr-2" aria-hidden="true"
                                        :class="{ falseIcon: row.status == false }"></i>
                                    {{ row.label }}
                                    <i class="fa fa-info-circle cursor-pointer" aria-hidden="true" :title="row.label"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="secondaryHeading mb-2">Review Breakdown</div>
                            <div class="space-between-header" v-for="(row, i) in viewLqsListingdata.review_breakdown"
                                :key="'lqs_cb' + i">
                                <div class="textColor" style="text-transform: capitalize">
                                    <i class="fa fa-circle trueIcon mr-2" aria-hidden="true"
                                        :class="{ falseIcon: row.status == false }"></i>
                                    {{ row.label }}
                                    <i class="fa fa-info-circle cursor-pointer" aria-hidden="true" :title="row.label"></i>
                                </div>
                            </div>
                            <div class="singatureLogo">
                                <div style="font-size: 14px" class="text-secondary">Powered By</div>
                                <img src="img/brand/brand_logos/Logos-18.png" width="72" />
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="row space-between" v-if="showDetailsLqsData.length == 0">
                <div class="col-12">
                    <div class="card mb-2 d-flex justify-content-between align-items-center flex-row"
                        :class="[keyCheck ? 'mt-3' : 'mt-0']" v-if="viewASINsDetailedData">
                        <div style="margin: 0; padding-bottom: 0 !important" class="graphHeading"
                            v-if="viewASINsDetailedData">
                            <h1 v-if="viewASINsDetailedData.length != 0" class="showAsinHeading font-weight-bold mb-0">
                                {{ translatedLang["Analysis"][selectedLanguage.key] }} : {{
                                    viewASINsDetailedData[0].asins ? viewASINsDetailedData[0].asins :
                                        viewASINsDetailedData[0].asin ? viewASINsDetailedData[0].asin : '' }}</h1>
                        </div>
                        <div class="d-flex align-items-center">
                            <div v-if="viewASINsDetailedData.length != 0">
                                <span style="color: var(--primary_brand); font-size: 16px" class="mr-3"
                                    v-if="viewASINsDetailedData[0].lqs_analysis.product_meta.product_link.includes('www.amazon.in')">
                                    <img src="../../../public/img/IndiaFlag.svg" width="22" class="">
                                    {{ translatedLang["amazon.in"][selectedLanguage.key] }} </span>
                                <span style="color: var(--primary_brand); font-size: 16px" class="mr-3"
                                    v-if="viewASINsDetailedData[0].lqs_analysis.product_meta.product_link.includes('www.amazon.com')">
                                    <img src="../../../public/img/USflag.svg" width="22" class="">
                                    {{ translatedLang["amazon.com"][selectedLanguage.key] }}
                                </span>
                            </div>
                            <div class="lastUpdatedDate rounded mr-3"
                                v-if="viewASINsDetailedData.length != 0 && keyCheck">
                                <button class="btn"> {{ translatedLang["Last Updated"][selectedLanguage.key] }}: {{
                                    viewASINsDetailedData[0].timestamp }}</button>
                            </div>
                            <div @click="goBack" style="text-decoration: none; float: right" v-if="keyCheck">
                                <button style="width: max-content; float: right" class="btn navigationButton"
                                    type="button">
                                    <i class="fa fa-arrow-left"></i>
                                    <span style="font-size: 13px"> {{ translatedLang["Back"][selectedLanguage.key] }}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-deck mt-2" v-if="viewASINsDetailedData.length != 0 && showDetailsLqsData.length == 0">
                <div class="card">
                    <h5 class="borderHeading pb-3"> {{ translatedLang["Listing Quality Score"][selectedLanguage.key] }}</h5>
                    <div class="d-flex justify-content-center align-items-center mt-4">
                        <div class="w-50 mr-4">
                            <div>
                                <highcharts :options="gaugeChartData"></highcharts>
                            </div>
                        </div>
                        <!-- <p class="w-50">Listing Quality Score</p> -->
                    </div>
                </div>
                <div class="card">
                    <h5 class="borderHeading pb-3">{{ translatedLang["Product Description"][selectedLanguage.key] }}</h5>
                    <div class="d-flex">
                        <div class="productImgContainer w-50 mr-4 rounded"
                            style="background: linear-gradient(270deg, rgba(0, 0, 0, 0.05) 0%, rgba(255, 255, 255, 0) 100%);">
                            <img :src="viewASINsDetailedData[0].lqs_analysis.product_meta.product_image"
                                alt="product img" class="img-fluid"
                                style="mix-blend-mode: multiply; object-fit: cover;" />
                        </div>
                        <div class="productHeadingContainer w-75 pt-4">
                            <a :href="viewASINsDetailedData[0].lqs_analysis.product_meta.product_link" target="_blanck"
                                class="cursor-pointer">{{
                                    viewASINsDetailedData[0].lqs_analysis.product_meta.product_name }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-2" v-if="showDetailsLqsData.length == 0">
                <div class="col-12">
                    <div class="card">
                        <h5 class="borderHeading pb-3 mb-3">{{ translatedLang["Listing Quality Score"][selectedLanguage.key]
                            }}<span class="text-body">:
                                Insights</span></h5>
                        <div class="row" v-if="viewASINsDetailedData.length != 0">
                            <div class="col-4">
                                <div class="copyBreakdownContainer breakdownSideBorder">
                                    <b-btn @click="toggleCollapse1"
                                        class="border-0 d-flex justify-content-between align-items-center copyBreakdownHeading w-100 py-3 breakDownHeading">
                                        <div>{{ translatedLang["Copy Breakdown"][selectedLanguage.key] }}</div>
                                        <div class="d-flex align-items-center">
                                            <div class="breakdownIssueCount text-white py-1 px-3 rounded mr-4">{{
                                                breakdownIssuesCalculate(viewASINsDetailedData[0].lqs_analysis.copy_breakdown)
                                            }}
                                            </div>
                                            <div>
                                                <img v-if="isCollapsed1" src="Icons_SVG/upArrowLQS.svg" alt="" srcset=""
                                                    height="10">
                                                <img v-else src="Icons_SVG/downArrowLQS.svg" alt="" srcset=""
                                                    height="10">
                                            </div>
                                        </div>
                                    </b-btn>
                                    <b-collapse :visible="isCollapsed1" class="pb-4">
                                        <!-- <p class="breakdownContentClass mb-0 p-3">Lorem ipsum dolor sit amet,
                                            consectetur adipiscing
                                            Lorem ipsum dolor sit amet, consectetur adipiscing </p> -->
                                        <div class="d-flex justify-content-start align-items-center pt-3 pl-3 pr-3"
                                            v-for="items in viewASINsDetailedData[0].lqs_analysis.copy_breakdown"
                                            :key="items">
                                            <div class="mr-2">
                                                <img v-if="items.status" src="Icons_SVG/checkIcon.svg" height="18"
                                                    width="18" class="checkIconBreakdown rounded-circle p-1" />
                                                <img v-else src="Icons_SVG/crossIcon.svg" height="18" width="18"
                                                    class="crossIconBreakdown rounded-circle p-1" />
                                            </div>
                                            <div :class="[items.status ? 'breakdownLables' : 'breakdownLablesRed']">
                                                <div class="d-flex align-items-center">
                                                    <h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">{{
                                                        items.label }}</h5>
                                                    <i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2"
                                                        aria-hidden="true" :title="items.info"></i>
                                                </div>
                                                <p class="mb-0" v-if="Array.isArray(items.current)">{{
                                                    translatedLang["Current"][selectedLanguage.key] }} : {{
                                                        items.current.join(', ') }}</p>
                                                <p class="mb-0" v-else-if="items.current">{{
                                                    translatedLang["Current"][selectedLanguage.key] }} : {{ items.current }}
                                                </p>
                                            </div>
                                        </div>
                                    </b-collapse>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="mediaBreakdownContainer breakdownSideBorder">
                                    <b-btn @click="toggleCollapse2"
                                        class="border-0 d-flex justify-content-between align-items-center mediaBreakdownHeading w-100 py-3 breakDownHeading">
                                        <div>{{ translatedLang["Media Breakdown"][selectedLanguage.key] }}</div>
                                        <div class="d-flex align-items-center">
                                            <div class="breakdownIssueCount text-white py-1 px-3 rounded mr-4">{{
                                                breakdownIssuesCalculate(viewASINsDetailedData[0].lqs_analysis.media_breakdown)
                                            }}
                                            </div>
                                            <div>
                                                <img v-if="isCollapsed2" src="Icons_SVG/upArrowLQS.svg" alt="" srcset=""
                                                    height="10">
                                                <img v-else src="Icons_SVG/downArrowLQS.svg" alt="" srcset=""
                                                    height="10">
                                            </div>
                                        </div>
                                    </b-btn>
                                    <b-collapse :visible="isCollapsed2" class="pb-4">
                                        <!-- <p class="breakdownContentClass mb-0 p-3">Lorem ipsum dolor sit amet,
                                            consectetur adipiscing
                                            Lorem ipsum dolor sit amet, consectetur adipiscing </p> -->
                                        <div class="d-flex justify-content-start align-items-center pt-3 pl-3 pr-3"
                                            v-for="items in viewASINsDetailedData[0].lqs_analysis.media_breakdown"
                                            :key="items">
                                            <div class="mr-2">
                                                <img v-if="items.status" src="Icons_SVG/checkIcon.svg" height="18"
                                                    width="18" class="checkIconBreakdown rounded-circle p-1" />
                                                <img v-else src="Icons_SVG/crossIcon.svg" height="18" width="18"
                                                    class="crossIconBreakdown rounded-circle p-1" />
                                            </div>
                                            <div :class="[items.status ? 'breakdownLables' : 'breakdownLablesRed']">
                                                <div class="d-flex align-items-center">
                                                    <h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">{{
                                                        items.label }}</h5>
                                                    <i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2"
                                                        aria-hidden="true" :title="items.info"></i>
                                                </div>
                                                <p class="mb-0" v-if="Array.isArray(items.current)">{{
                                                    translatedLang["Current"][selectedLanguage.key] }} : {{
                                                        items.current.join(', ') }}</p>
                                                <p class="mb-0" v-else-if="items.current">{{
                                                    translatedLang["Current"][selectedLanguage.key] }} : {{ items.current }}
                                                </p>
                                            </div>
                                        </div>
                                    </b-collapse>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="reviewBreakdownContainer breakdownSideBorder">
                                    <b-btn @click="toggleCollapse3"
                                        class="border-0 d-flex justify-content-between align-items-center reviewBreakdownHeading w-100 py-3 breakDownHeading">
                                        <div>{{ translatedLang["Review Breakdown"][selectedLanguage.key] }}</div>
                                        <div class="d-flex align-items-center">
                                            <div class="breakdownIssueCount text-white py-1 px-3 rounded mr-4">{{
                                                breakdownIssuesCalculate(viewASINsDetailedData[0].lqs_analysis.review_breakdown)
                                            }}
                                            </div>
                                            <div>
                                                <img v-if="isCollapsed3" src="Icons_SVG/upArrowLQS.svg" alt="" srcset=""
                                                    height="10">
                                                <img v-else src="Icons_SVG/downArrowLQS.svg" alt="" srcset=""
                                                    height="10">
                                            </div>
                                        </div>
                                    </b-btn>
                                    <b-collapse :visible="isCollapsed3" class="pb-4">
                                        <!-- <p class="breakdownContentClass mb-0 p-3">Lorem ipsum dolor sit amet,
                                            consectetur adipiscing
                                            Lorem ipsum dolor sit amet, consectetur adipiscing </p> -->
                                        <div class="d-flex justify-content-start align-items-center pt-3 pl-3 pr-3"
                                            v-for="items in viewASINsDetailedData[0].lqs_analysis.review_breakdown"
                                            :key="items">
                                            <div class="mr-2">
                                                <img v-if="items.status" src="Icons_SVG/checkIcon.svg" height="18"
                                                    width="18" class="checkIconBreakdown rounded-circle p-1" />
                                                <img v-else src="Icons_SVG/crossIcon.svg" height="18" width="18"
                                                    class="crossIconBreakdown rounded-circle p-1" />
                                            </div>
                                            <div :class="[items.status ? 'breakdownLables' : 'breakdownLablesRed']">
                                                <div class="d-flex align-items-center">
                                                    <h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">{{
                                                        items.label }}</h5>
                                                    <i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2"
                                                        aria-hidden="true" :title="items.info"></i>
                                                </div>
                                                <p class="mb-0" v-if="Array.isArray(items.current)">{{
                                                    translatedLang["Current"][selectedLanguage.key] }} : {{
                                                        items.current.join(', ') }}</p>
                                                <p class="mb-0" v-else-if="items.current">{{
                                                    translatedLang["Current"][selectedLanguage.key] }} : {{ items.current }}
                                                </p>
                                            </div>
                                        </div>
                                    </b-collapse>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div v-if="showDetailsLqsData.length != 0">
                <div class="row space-between">
                    <div class="col-12">
                        <div class="card mb-2 d-flex justify-content-between align-items-center flex-row mt-3">
                            <div style="margin: 0; padding-bottom: 0 !important" class="graphHeading">
                                <h1 v-if="showDetailsLqsData.length != 0" class="font-weight-bold showAsinHeading mb-0">
                                    {{ translatedLang["Analysis"][selectedLanguage.key] }} : {{
                                        showDetailsLqsData[0].asins ? viewASINsDetailedData[0].asins :
                                            viewASINsDetailedData[0].asin ? viewASINsDetailedData[0].asin : '' }}</h1>
                            </div>
                            <div class="d-flex align-items-center">
                                <div v-if="showDetailsLqsData.length != 0">
                                    <span style="color: var(--primary_brand); font-size: 16px" class="mr-3"
                                        v-if="showDetailsLqsData[0].lqs_analysis.product_meta.product_link.includes('www.amazon.in')">
                                        <img src="../../../public/img/IndiaFlag.svg" width="22" class="">
                                        {{ translatedLang["amazon.in"][selectedLanguage.key] }} </span>
                                    <span style="color: var(--primary_brand); font-size: 16px" class="mr-3"
                                        v-if="showDetailsLqsData[0].lqs_analysis.product_meta.product_link.includes('www.amazon.com')">
                                        <img src="../../../public/img/USflag.svg" width="22" class="">
                                        {{ translatedLang["amazon.in"][selectedLanguage.key] }}
                                    </span>
                                </div>
                                <div class="lastUpdatedDate rounded mr-3" v-if="showDetailsLqsData.length != 0">
                                    <button class="btn">{{ showDetailsLqsData[0].timestamp }}</button>
                                </div>
                                <router-link to="/lqs-analyser" style="text-decoration: none; float: right">
                                    <button style="width: max-content; float: right" class="btn navigationButton"
                                        type="button">
                                        <i class="fa fa-arrow-left"></i>
                                        <span style="font-size: 13px"> {{ translatedLang["Back"][selectedLanguage.key]
                                            }}</span>
                                    </button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-deck mt-2" v-if="showDetailsLqsData.length != 0">
                    <div class="card">
                        <h5 class="borderHeading pb-3"> {{ translatedLang["Listing Quality Score"][selectedLanguage.key] }}
                        </h5>
                        <div class="d-flex justify-content-center align-items-center mt-4">
                            <div class="w-50 mr-4">
                                <div>
                                    <highcharts :options="gaugeChartData"></highcharts>
                                </div>
                            </div>
                            <!-- <p class="w-50">Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem totam
                                consectetur fugiat
                                inventore id perspiciatis neque temporibus officia magni corporis?</p> -->
                        </div>
                    </div>
                    <div class="card">
                        <h5 class="borderHeading pb-3">{{ translatedLang["Product Description"][selectedLanguage.key] }}
                        </h5>
                        <div class="d-flex">
                            <div class="productImgContainer w-50 mr-4 rounded"
                                style="background: linear-gradient(270deg, rgba(0, 0, 0, 0.05) 0%, rgba(255, 255, 255, 0) 100%);">
                                <img :src="showDetailsLqsData[0].lqs_analysis.product_meta.product_image"
                                    alt="product img" class="img-fluid"
                                    style="mix-blend-mode: multiply; object-fit: cover; height: 100%; " />
                            </div>
                            <div class="productHeadingContainer w-75 pt-4">
                                <a :href="showDetailsLqsData[0].lqs_analysis.product_meta.product_link" target="_blanck"
                                    class="cursor-pointer">{{
                                        showDetailsLqsData[0].lqs_analysis.product_meta.product_name }}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <div class="card">
                            <h5 class="borderHeading pb-3 mb-3">
                                {{ translatedLang["Listing Quality Score"][selectedLanguage.key] }}
                                <span class="text-body">:
                                    {{ translatedLang["Insights"][selectedLanguage.key] }} </span>
                            </h5>
                            <div class="row" v-if="showDetailsLqsData.length != 0">
                                <div class="col-4">
                                    <div class="copyBreakdownContainer breakdownSideBorder">
                                        <b-btn @click="toggleCollapse1"
                                            class="border-0 d-flex justify-content-between align-items-center copyBreakdownHeading w-100 py-3 breakDownHeading">
                                            <div>{{ translatedLang["Copy Breakdown"][selectedLanguage.key] }}</div>
                                            <div class="d-flex align-items-center">
                                                <div class="breakdownIssueCount text-white py-1 px-3 rounded mr-4">{{
                                                    breakdownIssuesCalculate(showDetailsLqsData[0].lqs_analysis.copy_breakdown)
                                                    }}
                                                </div>
                                                <div>
                                                    <img v-if="isCollapsed1" src="Icons_SVG/upArrowLQS.svg" alt=""
                                                        srcset="" height="10">
                                                    <img v-else src="Icons_SVG/downArrowLQS.svg" alt="" srcset=""
                                                        height="10">
                                                </div>
                                            </div>
                                        </b-btn>
                                        <b-collapse :visible="isCollapsed1" class="pb-4">
                                            <!-- <p class="breakdownContentClass mb-0 p-3">Lorem ipsum dolor sit amet,
                                                consectetur adipiscing
                                                Lorem ipsum dolor sit amet, consectetur adipiscing </p> -->
                                            <div class="d-flex justify-content-start align-items-center pt-3 pl-3 pr-3"
                                                v-for="items in showDetailsLqsData[0].lqs_analysis.copy_breakdown">
                                                <div class="mr-2">
                                                    <img v-if="items.status" src="Icons_SVG/checkIcon.svg" height="18"
                                                        width="18" class="checkIconBreakdown rounded-circle p-1" />
                                                    <img v-else src="Icons_SVG/crossIcon.svg" height="18" width="18"
                                                        class="crossIconBreakdown rounded-circle p-1" />
                                                </div>
                                                <div :class="[items.status ? 'breakdownLables' : 'breakdownLablesRed']">
                                                    <div class="d-flex align-items-center">
                                                        <h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">{{
                                                            items.label }}</h5>
                                                        <i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2"
                                                            aria-hidden="true" :title="items.info"></i>
                                                    </div>
                                                    <p class="mb-0" v-if="Array.isArray(items.current)">{{
                                                        translatedLang["Current"][selectedLanguage.key] }} : {{
                                                            items.current.join(', ') }}
                                                    </p>
                                                    <p class="mb-0" v-else-if="items.current">{{
                                                        translatedLang["Current"][selectedLanguage.key] }} : {{
                                                            items.current
                                                        }}</p>
                                                </div>
                                            </div>
                                        </b-collapse>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="mediaBreakdownContainer breakdownSideBorder">
                                        <b-btn @click="toggleCollapse2"
                                            class="border-0 d-flex justify-content-between align-items-center mediaBreakdownHeading w-100 py-3 breakDownHeading">
                                            <div>{{ translatedLang["Media Breakdown"][selectedLanguage.key] }}</div>
                                            <div class="d-flex align-items-center">
                                                <div class="breakdownIssueCount text-white py-1 px-3 rounded mr-4">{{
                                                    breakdownIssuesCalculate(showDetailsLqsData[0].lqs_analysis.media_breakdown)
                                                    }}
                                                </div>
                                                <div>
                                                    <img v-if="isCollapsed2" src="Icons_SVG/upArrowLQS.svg" alt=""
                                                        srcset="" height="10">
                                                    <img v-else src="Icons_SVG/downArrowLQS.svg" alt="" srcset=""
                                                        height="10">
                                                </div>
                                            </div>
                                        </b-btn>
                                        <b-collapse :visible="isCollapsed2" class="pb-4">
                                            <!-- <p class="breakdownContentClass mb-0 p-3">Lorem ipsum dolor sit amet,
                                                consectetur adipiscing
                                                Lorem ipsum dolor sit amet, consectetur adipiscing </p> -->
                                            <div class="d-flex justify-content-start align-items-center pt-3 pl-3 pr-3"
                                                v-for="items in showDetailsLqsData[0].lqs_analysis.media_breakdown">
                                                <div class="mr-2">
                                                    <img v-if="items.status" src="Icons_SVG/checkIcon.svg" height="18"
                                                        width="18" class="checkIconBreakdown rounded-circle p-1" />
                                                    <img v-else src="Icons_SVG/crossIcon.svg" height="18" width="18"
                                                        class="crossIconBreakdown rounded-circle p-1" />
                                                </div>
                                                <div :class="[items.status ? 'breakdownLables' : 'breakdownLablesRed']">
                                                    <div class="d-flex align-items-center">
                                                        <h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">{{
                                                            items.label }}</h5>
                                                        <i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2"
                                                            aria-hidden="true" :title="items.info"></i>
                                                    </div>
                                                    <p class="mb-0" v-if="Array.isArray(items.current)">{{
                                                        translatedLang["Current"][selectedLanguage.key] }} : {{
                                                            items.current.join(', ') }}
                                                    </p>
                                                    <p class="mb-0" v-else-if="items.current">{{
                                                        translatedLang["Current"][selectedLanguage.key] }} : {{
                                                            items.current
                                                        }}</p>
                                                </div>
                                            </div>
                                        </b-collapse>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="reviewBreakdownContainer breakdownSideBorder">
                                        <b-btn @click="toggleCollapse3"
                                            class="border-0 d-flex justify-content-between align-items-center reviewBreakdownHeading w-100 py-3 breakDownHeading">
                                            <div>{{ translatedLang["Review Breakdown"][selectedLanguage.key] }}</div>
                                            <div class="d-flex align-items-center">
                                                <div class="breakdownIssueCount text-white py-1 px-3 rounded mr-4">{{
                                                    breakdownIssuesCalculate(showDetailsLqsData[0].lqs_analysis.review_breakdown)
                                                    }}
                                                </div>
                                                <div>
                                                    <img v-if="isCollapsed3" src="Icons_SVG/upArrowLQS.svg" alt=""
                                                        srcset="" height="10">
                                                    <img v-else src="Icons_SVG/downArrowLQS.svg" alt="" srcset=""
                                                        height="10">
                                                </div>
                                            </div>
                                        </b-btn>
                                        <b-collapse :visible="isCollapsed3" class="pb-4">
                                            <!-- <p class="breakdownContentClass mb-0 p-3">Lorem ipsum dolor sit amet,
                                                consectetur adipiscing
                                                Lorem ipsum dolor sit amet, consectetur adipiscing </p> -->
                                            <div class="d-flex justify-content-start align-items-center pt-3 pl-3 pr-3"
                                                v-for="items in showDetailsLqsData[0].lqs_analysis.review_breakdown">
                                                <div class="mr-2">
                                                    <img v-if="items.status" src="Icons_SVG/checkIcon.svg" height="18"
                                                        width="18" class="checkIconBreakdown rounded-circle p-1" />
                                                    <img v-else src="Icons_SVG/crossIcon.svg" height="18" width="18"
                                                        class="crossIconBreakdown rounded-circle p-1" />
                                                </div>
                                                <div :class="[items.status ? 'breakdownLables' : 'breakdownLablesRed']">
                                                    <div class="d-flex align-items-center">
                                                        <h5 :class="[items.current ? 'mb-1 mt-0' : 'mb-0 mt-1']">{{
                                                            items.label }}</h5>
                                                        <i class="fa fa-info-circle bgInfoColor cursor-pointer ml-2"
                                                            aria-hidden="true" :title="items.info"></i>
                                                    </div>
                                                    <p class="mb-0" v-if="Array.isArray(items.current)">{{
                                                        translatedLang["Current"][selectedLanguage.key] }} : {{
                                                            items.current.join(', ') }}
                                                    </p>
                                                    <p class="mb-0" v-else-if="items.current">{{
                                                        translatedLang["Current"][selectedLanguage.key] }} : {{
                                                            items.current
                                                        }}</p>
                                                </div>
                                            </div>
                                        </b-collapse>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-2" v-if="checkHasMultiple()">
                <div class="col-12">
                    <div class="card">
                        <h5 class="borderHeading pb-3 mb-3">{{ translatedLang["History"][selectedLanguage.key] }}</h5>
                        <div class="rounded mb-3" v-for="(items, month) in paginatedStoreLqsDataByMonthGroup">
                            <h3 class="monthNameHeading">{{ month }}</h3>
                            <div v-for="data in items" class="historyBorder d-flex mt-3 rounded">
                                <div
                                    class="historyDate p-3 d-flex justify-content-center align-items-center text-center">
                                    {{
                                        data.timestamp.split(',')[1] }}</div>
                                <div class="p-3 d-flex justify-content-between align-items-center w-100">
                                    <div>{{translatedLang["Listing Score"][selectedLanguage.key]}} : {{ data.total }}</div>
                                    <div class="dotCustom">{{ translatedLang["Copy Breakdown"][selectedLanguage.key] }} : {{
                                        breakdownIssuesCalculate(data.lqs_analysis.copy_breakdown)
                                    }} <span style="color: #000; font-weight:500">{{
                                            translatedLang["Issues"][selectedLanguage.key] }}</span></div>
                                    <div class="dotCustom">{{ translatedLang["Media Breakdown"][selectedLanguage.key] }} :
                                        {{
                                            breakdownIssuesCalculate(data.lqs_analysis.media_breakdown) }} <span
                                            style="color: #000; font-weight:500">{{
                                                translatedLang["Issues"][selectedLanguage.key] }}</span></div>
                                    <div class="dotCustom">{{ translatedLang["Review Breakdown"][selectedLanguage.key] }} :
                                        {{
                                            breakdownIssuesCalculate(data.lqs_analysis.review_breakdown) }}
                                        <span style="color: #000; font-weight:500">{{
                                            translatedLang["Issues"][selectedLanguage.key] }}</span>
                                    </div>
                                    <button class="btn primarycolorShow" @click="historyDetailsData(data)">{{
                                        translatedLang["Show Details"][selectedLanguage.key] }}</button>
                                </div>
                            </div>
                        </div>
                        <div v-if="checkShowPagination"
                            class="lqsHistoryPagination d-flex justify-content-center align-items-center">
                            <button class="lqsHistoryPreviousBtn rounded" @click="previousPage"
                                :disabled="currentPage === 1">{{ translatedLang["Previous"][selectedLanguage.key]
                                }}</button>
                            <span class="mx-3">{{ translatedLang["Page"][selectedLanguage.key] }} {{ currentPage }} {{
                                translatedLang["of"][selectedLanguage.key] }} {{ totalPages }}</span>
                            <button class="lqsHistoryNextBtn rounded" @click="nextPage"
                                :disabled="currentPage === totalPages">{{ translatedLang["Next"][selectedLanguage.key]
                                }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import html2canvas from 'html2canvas';
import { mapState, mapActions } from "vuex";

export default {
    name: "LqsCard",
    props: ["viewASINsDetailedData", "storeLqsDataByMonthGroup", "keyCheck"],

    data: function () {
        return {
            gaugeChartData: {},
            // inputSearchkey: "",
            loader: false,
            asin: "",
            isCollapsed1: true,
            isCollapsed2: false,
            isCollapsed3: false,
            showDetailsLqsData: [],
            currentPage: 1,
            itemsPerPage: 5,
        };
    },
    computed: {
        ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),

        totalPages() {
            const totalItems = Object.values(this.storeLqsDataByMonthGroup).reduce((acc, items) => acc + items.length, 0);
            return Math.ceil(totalItems / this.itemsPerPage);
        },
        paginatedStoreLqsDataByMonthGroup() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = this.currentPage * this.itemsPerPage;
            let count = 0;
            const result = {};

            for (const [month, items] of Object.entries(this.storeLqsDataByMonthGroup)) {
                if (count >= end) break;
                const sliceStart = Math.max(start - count, 0);
                const sliceEnd = Math.min(items.length, end - count);

                if (sliceStart < sliceEnd) {
                    result[month] = items.slice(sliceStart, sliceEnd);
                }

                count += items.length;
            }

            return result;
        },
        checkShowPagination() {
            return this.totalPages > 1
        },
    },
    watch: {},

    mounted() {
        this.gaugeChart();
    },
    //     computed: {
    //     ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
    //   },
    methods: {
        ...mapActions("DemoStore", [
            "setSelectedLanguage",
            "initializeTranslation",
        ]),
        goBack() {
            window.history.back();
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        toggleCollapse1() {
            this.isCollapsed1 = !this.isCollapsed1;
        },
        toggleCollapse2() {
            this.isCollapsed2 = !this.isCollapsed2;
        },
        toggleCollapse3() {
            this.isCollapsed3 = !this.isCollapsed3;
        },
        checkHasMultiple() {
            return this.viewASINsDetailedData.length > 1;
        },
        checkCurrentArray(index, items) {
            return index < items.length - 1
        },
        historyDetailsData(data) {
            this.showDetailsLqsData = [];
            if (this.showDetailsLqsData.length == 0) {
                this.showDetailsLqsData.push(data);
            }
            this.gaugeChart(data.total)
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });

        },

        breakdownIssuesCalculate(data) {
            let calcaluteIssueCount = 0;
            data.forEach(items => {
                if (!items.status) {
                    calcaluteIssueCount++
                }
            })
            return calcaluteIssueCount;
        },

        // chartHeight() {
        //     if (window.screen.width < 1600) {
        //         return "60%"
        //     }
        //     else
        //         return "70%"
        // },
        // chartSize() {
        //     if (window.screen.width < 1600) {
        //         return '40%'
        //     }
        //     else
        //         return "100%"
        // },
        chartHeight() {
            if (window.screen.width < 1400) {
                return 200
            }
            else
                return 175
        },
        chartSize() {
            if (window.screen.width < 1400) {
                return 200
            }
            else
                return 270
        },
        gaugeChart(totalCount) {
            let self = this;
            this.gaugeChartData = {
                chart: {
                    type: "solidgauge",
                    height: this.chartHeight(),
                    plotBackgroundImage: null,
                    backgroundColor: 'transparent',
                    spacing: [0, 0, 0, 0],
                    marginTop: -90
                },

                title: {
                    text: '',
                },
                credits: {
                    enabled: false,
                },
                pane: {
                    startAngle: -90,
                    endAngle: 90,
                    background: {
                        backgroundColor: '#E5E5E5',
                        borderWidth: 0,
                        innerRadius: '60%',
                        outerRadius: '100%',
                        shape: 'arc'
                    },
                    center: ['50%', '85%'],
                    size: this.chartSize()
                },

                exporting: {
                    enabled: false,
                },

                tooltip: {
                    enabled: false,
                },

                yAxis: {
                    min: 0,
                    max: 10,
                    stops: [
                        [0.1, '#06555999'],
                        [0.4, '#06555999'],
                        [0.8, '#06555999'],
                    ],
                    lineWidth: 0,
                    tickWidth: 0,
                    minorTickInterval: null,
                    tickAmount: 2,
                    labels: {
                        enabled: false,
                    },
                    plotBands: [
                        {
                            from: 0,
                            to: 10,
                            color: '#F3F3F3',
                        }
                    ],
                },

                plotOptions: {
                    solidgauge: {
                        dataLabels: {
                            enabled: true,
                            y: 10,
                            borderWidth: 0,
                            useHTML: true,
                            format: '<div style="text-align:center"><span style="font-size:40px;color:#065559;font-weight:500;">{y}</span></div>',
                        },
                    },
                },

                series: [{
                    name: 'Listing Quality Score',
                    data: [totalCount],
                    tooltip: {
                        valueSuffix: ''
                    },
                    color: '#065559',
                    radius: '80%',
                    innerRadius: '100%',
                    thickness: 20
                }]
            };
        },


        async takeScreenshot() {
            let self = this
            let id = "#LqsAnalyser" + this.asinData;
            let uniqueCardId = document.querySelector(id);
            let getScreenshotDiv = uniqueCardId.querySelector('.screenshot-btn');
            getScreenshotDiv.classList.add('screenshot-hide-btn');
            html2canvas(uniqueCardId, { useCORS: true }).then(function (canvas) {
                canvas.style.display = "none"
                document.body.appendChild(canvas);
                const image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
                const a = document.createElement("a");
                a.setAttribute("download", `Weavr-LQS-${self.asinData}.png`);
                a.setAttribute("href", image);
                a.click();
                getScreenshotDiv.classList.remove('screenshot-hide-btn');
            });
        },
    },
};
</script>

<style scoped>
.space-between {
    display: flex;
    justify-content: space-between;
}

.cursor-pointer {
    cursor: pointer;
}

.flex-start {
    display: flex;
    justify-content: start;
}

.mainHeading {
    color: #4e4e4e;
    margin-bottom: 0;
    font-size: 1.3125rem;
}

.secondaryHeading {
    color: #4e4e4e;
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: bold;
}

.textColor {
    color: #818890 !important;
}

.flex-start {
    display: flex;
    justify-content: flex-start;
}

.inputBox {
    height: 30px;
    border: 1px solid silver;
    display: flex;
    justify-content: start;
    background: white;
}

.inputBox input {
    border-radius: 0px;
    border: none !important;
}

.sideBorder {
    border-right: 1px solid #c1c1c1;
}

input:focus {
    outline: none !important;
    box-shadow: none !important;
}

.trueIcon {
    color: #64ac94 !important;
}

.falseIcon {
    color: #ff0000 !important;
}

.cardButton {
    margin-left: 10px;
}

.productCart {
    display: flex;
    justify-content: space-between;
    padding: 10px;
}

.productImg {
    width: 200px;
}

.product-title {
    font-size: 18px;
}

.productImg img {
    width: 100%;
}

.graphCount {
    font-size: 24px;
    color: "#533a79";
    font-weight: 700;
}

.asinBadge {
    /* background: '#9683b3'; */
    background: "#9683b3";
}

.cross-icon {
    color: black;
    background: white;
}

.crossIcon {
    cursor: pointer;
    font-size: 8px;
}

.space-between {
    display: flex;
    justify-content: space-between;
}

thead {
    background: none;
    font-family: sans-serif;
    background: #9683b3;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    /* padding: 10px; */
}

tbody {
    font-family: sans-serif;
    font-size: 13px;
}

.pinkColor {
    background: rgb(255 185 185);
    font-weight: bold;
}

.skyColor {
    background: rgb(199 224 255);
    font-weight: bold;
}

.no-data {
    font-size: 16px;
    text-align: center;
    padding: 10px;
    color: red;
}

.card {
    border-radius: 0.7rem !important;
    border: none !important;
    margin-bottom: 1rem;
}

.graphHeading {
    font-weight: 600 !important;
    font-size: 20px !important;
    color: var(--primary_brand) !important;
    letter-spacing: 0.6px !important;
    font-family: "poppins";
}

#LqsAnalyser {
    font-family: "poppins" !important;
}

.singatureLogo {
    position: absolute;
    bottom: 20px;
    right: 20px;
    text-align: center !important;
}

.screenshot-btn {
    transition: .4s linear !important;
}

.screenshot-btn .fa-download {
    color: var(--primary_brand) !important
}

.screenshot-btn:hover {
    background-color: #F2F1F6;
}

.screenshot-hide-btn {
    visibility: hidden;
}


/* css */

.borderHeading {
    border-bottom: 1px solid #D4D4D4;
    font-size: 16px;
    font-weight: 500 !important;
    color: var(--primary_brand) !important;
}

.productHeadingContainer a {
    color: #0463BA;
    font-size: 16px;
    font-weight: 500;
    line-height: 25px;
    text-decoration: underline;
}

.copyBreakdownContainer .copyBreakdownHeading {
    background-color: #009688CC !important;
    color: #fff !important;
}

.breakdownSideBorder {
    border: 1px solid #D9D9D9;
    border-radius: 15px;
}

.breakDownHeading {
    font-size: 20px;
    color: #fff;
    font-weight: 500;
    border-radius: 15px;
}

.breakDownHeading:focus {
    box-shadow: none !important;
    ;
}

.mediaBreakdownContainer .mediaBreakdownHeading {
    background-color: #6956E5CC !important;
    color: #fff !important;
}

.reviewBreakdownContainer .reviewBreakdownHeading {
    background-color: #FD5542CC !important;
    color: #fff !important;
}

.showAsinHeading {
    font-size: 18px;
    font-weight: 500;
}

.breakdownContentClass {
    color: #5E5E5E;
    font-size: 14px !important;
    border-bottom: 1px solid #D4D4D4;
}

.checkIconBreakdown {
    background-color: #50B767 !important;
}

.crossIconBreakdown {
    background-color: #8C0000 !important;
}

.breakdownLables h5,
.breakdownCollapsedFooter h5,
.breakdownLables p,
.breakdownCollapsedFooter p,
.breakdownLablesRed h5,
.breakdownLablesRed p {
    font-size: 14px !important;
}

.breakdownLables h5,
.breakdownCollapsedFooter h5,
.breakdownLablesRed h5 {
    font-weight: 500;
    color: #000000;
}

.breakdownLables p,
.breakdownCollapsedFooter p,
.breakdownLablesRed p {
    font-weight: 400;
    color: #5E5E5E;
}

.breakdownLablesRed h5,
.breakdownLablesRed p {
    color: #8C0000;
}

.breakdownCollapsedFooter button {
    background: #065559;
    padding: 8px 16px;
}

.breakdownCollapsedFooter>div {
    background-color: #F1F1F1CC;
    border-radius: 15px;
}

.breakdownCollapsedFooter {
    border-top: 1px solid #D9D9D9;
}

.breakdownIssueCount {
    background-color: #A11E26;
    font-size: 14px !important;
    font-weight: 500 !important;
}

.historyBorder {
    border: 1px solid #D9D9D9;
    border-radius: 15px !important;
}

.historyDate {
    border-right: 1px solid #D9D9D9;
}

button.primarycolorShow {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 6px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: 100;
    font-size: 14px;
}

button.primarycolorShow:hover {
    color: white;
    background: var(--primary_brand-80);
    /* border: 1.6px solid var(--base_color); */
}

.highcharts-series-group .highcharts-series path {
    fill: #065559 !important;
}

.monthNameHeading {
    color: #000000;
    font-size: 16px;
    font-weight: 500;
}

.bgInfoColor {
    color: #818181;
}

.lastUpdatedDate {
    border: 1px solid #065559 !important;
}

.lastUpdatedDate .btn {
    color: #065559 !important;
    font-size: 13px !important;
    border: 0 !important;
    cursor: text !important;
}

.lastUpdatedDate .btn:focus {
    box-shadow: none !important;
}

.navigationButton {
    height: 35px;
    border: none;
    margin: 0;
    background: var(--accent_color);
    color: white;
    border-radius: 5px;
    font-size: 14px;
    font-weight: bold;
    padding: 0px 20px;
    letter-spacing: 0.2px;
    font-family: "poppins";
}

.navigationButton:hover {
    background: var(--accent_color-80);
}

button.lqsHistoryNextBtn,
button.lqsHistoryPreviousBtn {
    border: 1px solid #ddd;
    border-radius: 8px;
}

.lqsHistoryPagination button[disabled="disabled"] {
    cursor: not-allowed !important;
}

.lqsHistoryPagination button:focus {
    box-shadow: none !important;
    border-color: #ddd !important;
    border: 1px solid #ddd !important;
}

.dotCustom {
    position: relative;
}

.dotCustom::before {
    content: "";
    position: absolute;
    background: #065559;
    width: 10px;
    height: 10px;
    left: -25px;
    top: 5px;
    border-radius: 50%;
}


.productImgContainer {
    display: flex;
    justify-content: center;
    padding: 15px;
    height: 200px;
}
</style>
